import { Set } from 'immutable';
import { combineReducers } from 'redux-immutable';

import { actionTypes } from 'actions/ptoPolicy';

const INITIAL_STATES = {
  isFetching: Set(),
};

const isFetching = (state = INITIAL_STATES.isFetching, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PTO_POLICY_REQUEST:
    case actionTypes.DELETE_PTO_POLICY_REQUEST:
      return state.add(action.meta.requestId);

    case actionTypes.DELETE_PTO_POLICY_SUCCESS:
    case actionTypes.DELETE_PTO_POLICY_FAILURE:
      return state.remove(action.meta.requestId);

    default:
      return state;
  }
};

export default combineReducers({
  isFetching,
});
